import { notification } from 'antd';

export const CopyToClipboardAction = (textToCopy: string, type: string) => {
  try {
    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = textToCopy;

    // Append the input element to the DOM
    document.body.appendChild(tempInput);

    // Select the text in the input element
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Execute the copy command
    document.execCommand('copy');

    // Remove the temporary input element
    document.body.removeChild(tempInput);

    // Show success notification
    notification[type]({
      message: '',
      description: 'Link Copied Successfully.',
      duration: 3,
    });
  } catch (error) {
    // Show error notification
    notification.error({
      message: '',
      description: 'Link Copied Failed.',
      duration: 3,
    });
  }
};
